import { Reorder } from "framer-motion";
import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Flex,
  ListItem,
  Text,
  UnorderedList,
} from "@chakra-ui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import colors from "utils/colors";

const ReorderItems = ({
  list,
  setList,
}: {
  list: any[];
  setList: (list: any[]) => void;
}) => {
  const reorderCategories = (items: any[]) => {
    setList(items);
  };

  const reorderItems = (category: string, items: any[]) => {
    const index = list.findIndex((group) => group.category === category);
    let shallowItems = [...list];
    let shallowGroup = { ...list[index] };

    shallowItems[index] = {
      ...shallowGroup,
      items,
    };

    setList(shallowItems);
  };

  return (
    <Reorder.Group axis="y" values={list} onReorder={reorderCategories}>
      {list.map((group, index) => (
        <Reorder.Item
          key={group.category}
          value={group}
          style={{ listStyleType: "none", padding: "0px", margin: "0px" }}
        >
          <Accordion mt="20px" allowMultiple={true}>
            <AccordionItem
              key={group.category}
              borderBottomWidth="1px"
              borderBottomColor="gray.50"
              borderTopWidth="0px"
            >
              <h2>
                <AccordionButton
                  data-cy={`checklist-category-${group.category}`}
                  px="0px"
                  cursor="move"
                >
                  <FontAwesomeIcon
                    icon={["far", "arrows-up-down"]}
                    size="sm"
                    color={colors.GRAY_200}
                  />
                  <Box
                    as="span"
                    flex="1"
                    textAlign="left"
                    fontSize="15px"
                    fontWeight="600"
                    ml="8px"
                  >
                    {group.category}
                  </Box>
                  <AccordionIcon />
                </AccordionButton>
              </h2>
              <AccordionPanel p={0}>
                <UnorderedList listStyleType="none" m="0" p="0" mb="15px">
                  <Reorder.Group
                    axis="y"
                    values={group.items}
                    onReorder={(items) => reorderItems(group.category, items)}
                  >
                    {group.items.map((item: any) => (
                      <Reorder.Item key={item.id} value={item}>
                        <ListItem py="5px" cursor="move">
                          <Flex
                            alignItems="center"
                            justifyContent="space-between"
                          >
                            <Flex alignItems="center">
                              <FontAwesomeIcon
                                icon={["far", "arrows-up-down"]}
                                size="sm"
                                color={colors.GRAY_200}
                              />
                              <Text fontWeight="500" fontSize="15px" ml="8px">
                                {item.title}
                              </Text>
                            </Flex>
                          </Flex>
                        </ListItem>
                      </Reorder.Item>
                    ))}
                  </Reorder.Group>
                </UnorderedList>
              </AccordionPanel>
            </AccordionItem>
          </Accordion>
        </Reorder.Item>
      ))}
    </Reorder.Group>
  );
};

export default ReorderItems;
